export enum LabelKind {
  FILL = "fill",
  LINE = "line"
}

export enum LabelColor {
  PRIMARY = "primary",
  DARK = "dark",
  NEGATIVE = "negative",
  POSITIVE = "positive"
}
